import Foryou from "../images/foryou.jpeg";
import RIPLEGEND from "../images/RipLegend.jpeg";
import noti0 from "../images/noti1.jpg";
import noti1 from "../images/noti2.jpg";
import noti2 from "../images/noti3.jpg";
import noti3 from "../images/noti4.jpg";
import noti4 from "../images/noti5.jpg";

var foryouData = {
  headlines: {
    img: {Foryou},
    subTitle: " News . LIVE",
    Title: " Johnny Depp and Amber Heard defamation trial reaches jury deliberation"

  },
  tweets: [
  {
    subhead: "Bollywood . Trending",
    title: "Prithviraj Sukumaran",
    nooftweets: "💔 https://pic.twitter.com/2ETbgkdlOG",
    image: {noti0}
  },
  {
    subhead: "Entertainment . Trending",
    title: "Swathishta",
    nooftweets: "Not a great pic in terms of quality, but worth a MILLION DOLLAR in terms of quantity....❤️ https://pic.twitter.com/CEX64a1tbV",
    image: {noti1}
  },{
    subhead: "Trending in India",
    title: "Pooly",
    nooftweets: "🦜 Over 5,500 Pooly holders 🦜",
    image: {noti2}
  },
  {
    subhead: "Celebrities . Trending",
    title: "Tim Beiko | timbeiko.eth 🐼",
    nooftweets: "Starting now 😄!",
    image: {noti3}
  },
  {
    subhead: "Trending in Actors",
    title: "Swathishta krishnan",
    nooftweets: "Frozen for a min ❤️ https://pic.twitter.com/o3v1WozLb5",
    image: {noti4}
  }]
};
export default foryouData;
